import { render } from "./App.vue?vue&type=template&id=5c9c3a65"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/data1/www/cms.jfinfo.com/jfinfo_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__